import { CrossBorderCode } from '@/domains/productDelivery/services/msfCheckoutFunnel/interfaces';

export type VATType = 'zero' | 'nonDeductible' | 'none';

export const getVATType = (statusCode?: CrossBorderCode): VATType => {
  switch (statusCode) {
    case CrossBorderCode.VATB2C:
    case CrossBorderCode.VATB2B_FRAUD:
    case CrossBorderCode.VATB2B_NOT_SUBJECT_TO_VAT:
    case CrossBorderCode.VATB2B_NONGB_LOCAL:
    case CrossBorderCode.VATB2B_NONGB_INTRACO_INVALID:
    case CrossBorderCode.VATB2B_RC_INVALID:
    case CrossBorderCode.VATB2B_GB_LOCAL:
    case CrossBorderCode.VATB2B_NI_LOCAL:
    case CrossBorderCode.VATB2B_NI_INTRACO_INVALID:
    case CrossBorderCode.VATB2B_BELGIUM:
      return 'none';

    case CrossBorderCode.VATB2B_NONGB_INTRACO_VALID:
    case CrossBorderCode.VATB2B_RC_VALID:
    case CrossBorderCode.VATB2B_ESIT_IMPORT_VALID:
    case CrossBorderCode.VATB2B_FRDE_IMPORT_VALID:
    case CrossBorderCode.VATB2B_GB_IMPORT_VALID_INF135:
    case CrossBorderCode.VATB2B_GB_IMPORT_VALID_SUP135:
    case CrossBorderCode.VATB2B_NI_INTRACO_VALID:
    case CrossBorderCode.VATB2B_NI_IMPORT_VALID:
      return 'zero';

    case CrossBorderCode.VATB2B_UNKNOWN_SHIPFROM:
    case CrossBorderCode.VATB2B_ALL_IMPORT_INVALID:
    case CrossBorderCode.VATB2B_FRDE_IMPORT_INVALID:
    case CrossBorderCode.VATB2B_GB_IMPORT_INVALID:
    case CrossBorderCode.VATB2B_NI_IMPORT_INVALID:
      return 'nonDeductible';

    default:
      return 'none';
  }
};
